import React, { useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { get } from "lodash";
import { ManageCommunicationMenu, LoaderWrapper } from "../../../components";
import { withAppLayout } from "../../../hoc";
import {
  manageCommunicationFormNames,
  MANAGE_COMMUNICATION_MENU,
} from "../../../utils";
import { ManageCommunicationRoutes } from "../../../routes";
import {
  manageCommunicationStore,
  ManageCommunicationProvider,
  setManageCommunicationSelectedMenu,
} from "../../../contexts";

export const ManageCommunication = (props) => {
  const { location } = props;
  const { state, dispatch } = useContext(manageCommunicationStore);
  const { isFetching } = get(state, "api", {});
  //const maintenanceId = get(state, "maintenanceId");
  const flow = get(state, "flow");
  // enven to handle location change
  useEffect(() => {
    dispatch(setManageCommunicationSelectedMenu(location.pathname));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const isLoading = get(state, "isLoading");
  return (
    <LoaderWrapper
      isLoading={isLoading || isFetching}
      className="row manage-company-wrapper"
    >
        <Col md={4} className="manage-report-column manage-menu-items">
            <div className="report-name-component">
              <div>
                <div>
                  <h6>Communication</h6>
                </div>
              </div>
            </div>
            <ManageCommunicationMenu
              menuList={MANAGE_COMMUNICATION_MENU}
              selectedMenu={get(state, "selectedMenu")}
              //maintenanceId={maintenanceId}
              flow={flow}
            />
            <div className="report-bottom-component"></div>
          </Col>
          <Col className="h-100 manage-menu-content w-50">
            <ManageCommunicationRoutes />
          </Col>
    </LoaderWrapper>
  );
};

const ManageMaintenanceWithProvider = (props) => {
  return (
    <ManageCommunicationProvider>
      <ManageCommunication {...props} />
    </ManageCommunicationProvider>
  );
};

export default withAppLayout(ManageMaintenanceWithProvider);
